<template>
    <base-dialog :loading="loading" :value="dialog" :width="400" :title="$t('student.rate_coach')" @input="onInput" @close="hide">
        <template v-if="coach">
            <div class="rate-sub">
                {{ $t('student.rate_coach_subtext', { name: coach.name }) }}
            </div>
            <div class="rate-stars">
                <v-rating v-model="stars" length="5" size="40" hover :color="starColor" background-color="outline2" />
            </div>
        </template>

        <template v-slot:footer>
            <v-btn class="footer-btn" depressed block :disabled="!stars" @click="ratingCoach" :loading="loading">
                {{ $t('common.confirm') }}
            </v-btn>
        </template>
    </base-dialog>
</template>

<script>

import { db } from "@/utils/Firebase";
import BaseDialog from "@/components/common/BaseDialog";

export default {
    components: { BaseDialog },
    props: {
        coach: {
            type: Object,
            default: null,
        }
    },
    data() {
        return {
            dialog: false,
            stars: 0,
            loading: false,
        }
    },
    computed: {
        coachId(vm = this) {
            return vm.coach?.id || vm.$route.params.uid
        },
        starColor(vm = this) {
            return vm.$vuetify.theme.dark ? 'primary' : 'accent'
        }
    },
    methods: {
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.stars = 0
        },
        onInput(val) {
            if (!val) this.hide()
        },
        async ratingCoach() {
            const vm = this
            await vm.withLoading(async () => {
                const starsAvg = vm.coach.rating ? vm.coach.rating.stars : 0
                let votesCount = vm.coach.rating ? vm.coach.rating.count : 0
                const starsSum = starsAvg * votesCount
                const starsGiven = vm.stars
                const totalStars = starsSum + starsGiven
                votesCount++
                const newStarsAvg = Math.round((totalStars / votesCount) * 100) / 100

                await db.collection('users').doc(vm.coachId).update({
                    rating: { stars: newStarsAvg, count: votesCount }
                })

                await db.collection('users').doc(vm.currentUser.uid).update({
                    'studentSubscription.rated': true,
                    'studentSubscription.lastRate': vm.$moment().format('YYYY-MM-DD')
                })

                vm.$emit('success')
                vm.hide()
            })
        }
    }
}

</script>

<style scoped>
.rate-sub {
    font-size: 14px;
    color: var(--v-txtSecondary-base);
    line-height: 1.4;
    margin-bottom: 20px;
}

.rate-stars {
    display: flex;
    justify-content: center;
    padding: 8px 0 12px;
}

.footer-btn.v-btn {
    height: 52px !important;
    border-radius: 0 !important;
    text-transform: none;
    letter-spacing: normal;
    font-weight: 700;
    box-shadow: none !important;
    background: var(--v-primary-base) !important;
    color: #0C0E12 !important;
}

.footer-btn.v-btn.v-btn--disabled {
    background: var(--v-surface2-base) !important;
    color: var(--v-txtMuted-base) !important;
}
</style>
